<template>
  <a-modal
    :title="formTitle"
    :visible="open"
    :width="960"
    :destroyOnClose="true"
    :maskClosable="false"
    :confirmLoading="submitLoading"
    wrapClassName="video-create-modal"
    :bodyStyle="{ maxHeight: '70vh', overflowY: 'auto' }"
    @ok="submitForm"
    @cancel="onClose"
  >
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="videoContent" >
        <span slot="label" >
          <a-tooltip>
            {{$t('描述')}}<template slot="title">{{$t('描述')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.videoContent" :placeholder="$t('通用.输入.请输入')" type="textarea" :auto-size="{ minRows: 2, maxRows: 6 }" allow-clear style="max-height: 160px; overflow-y: auto;" />
      </a-form-model-item>
      <!--      <a-col :md="6" :sm="24">-->
      <a-form-model-item :label="$t('类型')" prop="videoType"  >
        <a-select style="width: 100%" v-model="form.videoType" >
          <a-select-option v-for="(item, index) in this.customDict.VideoTypeEnum" :value="item.type"
                           :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-item
        v-if="form.videoType == '0'"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="请上传视频"
        prop="videoUrl"
      >
        <OssUploadSingle v-model="form.videoUrl" type="video" prefix="video" :maxSize="2048"></OssUploadSingle>
      </a-form-item>
      <a-form-model-item label="视频封面" prop="videoPic" v-if="form.videoType == '0'">
        <OssUploadSingle v-model="form.videoPic" type="img" prefix="video" :maxSize="10"></OssUploadSingle>
      </a-form-model-item>
      <a-form-model-item :label="$t('请上传图片')" prop="videoUrlList"  v-if="form.videoType == '1'">
        <OssUploadMulti v-model="form.videoUrlList" :isArrayData="true" prefix="video" type="img"></OssUploadMulti>
      </a-form-model-item>
      <a-form-model-item :label="$t('分类')" prop="videoPid">
        <a-select style="width: 100%" v-model="form.videoPid" :placeholder="$t('通用.输入.请选择')+$t('分类')" allowClear>
          <a-select-option v-for="(item, index) in categoryOptions" :value="String(item.id)" :key="index">
            {{ item.classifyName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('视频商品分类ids,逗号分隔')" prop="videoPids" v-if="formType === 1">-->
<!--        <a-select style="width: 100%" mode="multiple" v-model="form.videoPids" :placeholder="$t('通用.输入.请选择')+$t('分类')" allowClear>-->
<!--          <a-select-option v-for="(item, index) in categoryOptions" :value="String(item.id)" :key="index">-->
<!--            {{ item.classifyName }}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <!--  -->


      <!--      <a-form-model-item prop="atUser" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('@的用户id,逗号分隔')}}<template slot="title">{{$t('@的用户id,逗号分隔')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.atUser" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->

      <a-form-model-item :label="$t('话题')" prop="topicId" v-if="formType === 1">
        <a-select style="width: 100%" v-model="form.topicId" :placeholder="$t('通用.输入.请输入')+$t('话题')"
                  allowClear
                  :filter-option="false" :show-arrow="false" :not-found-content="null"
                  :default-active-first-option="false"
                  show-search
                  @search="handleTopicSearch"
                  @change="handleTopicChange">
          <a-select-option v-for="(item, index) in topicList" :value="item.id" :key="index">
            {{ item.topicTitle }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('发布者')" prop="creator" >
        <a-select style="width: 100%" :disabled="formType === 2" v-model="form.creator" :placeholder="$t('通用.输入.请输入')+$t('请选择发布人')"
                  allowClear
                  :filter-option="false" :show-arrow="false" :not-found-content="null"
                  :default-active-first-option="false"
                  show-search
                  @search="handleUserSearch"
                  @change="handleUserChange">
          <a-select-option v-for="(item, index) in userList" :value="item.id" :key="index">
            {{ item.nickName }}（{{ item.mobile }}）
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-item :label="$t('状态')" prop="videoState">
        <a-select :placeholder="$t('通用.输入.请选择')+$t('状态')" style="width: 100%" v-model="form.videoState" allowClear>
          <a-select-option v-for="(item, index) in this.customDict.VideoStatusEnum" :value="item.type"
                           :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-model-item prop="reason" :label="$t('审核不通过原因')">
        <a-input v-model="form.reason" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('审核不通过原因')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('发布地址')" v-if="formType === 2">
        <span style="word-break: break-word;">{{ form.address || '-' }}</span>
      </a-form-model-item>
      <a-form-model-item :label="$t('详细地址')" v-if="formType === 2">
        <span style="word-break: break-word;">{{ form.pubCity || '-' }}</span>
      </a-form-model-item>
<!--      <a-form-model-item :label="$t('发布动态内容')" prop="richContent" v-show="form.richContent">-->
<!--        <iframe-->
<!--          v-if="form.richContent"-->
<!--          class="rich-content-iframe"-->
<!--          :srcdoc="richContentSrcdoc"-->
<!--          sandbox="allow-same-origin"-->
<!--          frameborder="0"-->
<!--        ></iframe>-->
<!--      </a-form-model-item>-->
      <!--      <a-form-model-item prop="shareNum" v-if="formType === 1">-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('分享次数')}}<template slot="title">{{$t('分享次数')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.shareNum"  :placeholder="$t('通用.输入.请输入')+$t('分享次数')" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item prop="replyNum" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('被评论数量')}}<template slot="title">{{$t('评论数量')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.replyNum"  :placeholder="$t('通用.输入.请输入')+$t('被评论数量')" />-->
      <!--      </a-form-model-item>-->


      <!--      <a-form-model-item prop="pubLat" v-if="formType === 1">-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('发布经度')}}<template slot="title">{{$t('发布经度')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.pubLat" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('发布经度')" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item prop="pubLng" v-if="formType === 1">-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('发布纬度')}}<template slot="title">{{$t('发布纬度')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.pubLng" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('发布纬度')" />-->
      <!--      </a-form-model-item>-->

      <!--      <a-form-model-item prop="address" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('发布地址')}}<template slot="title">{{$t('发布地址')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.address" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('发布地址')" />-->
      <!--      </a-form-model-item>-->


      <!--      <a-form-model-item prop="pubCity" >-->
      <!--        <span slot="label" >-->
      <!--          <a-tooltip>-->
      <!--            {{$t('详细地址')}}<template slot="title">{{$t('详细地址')}}</template>-->
      <!--          </a-tooltip>-->
      <!--        </span>-->
      <!--        <a-input v-model="form.pubCity" :maxLength="255" :placeholder="$t('通用.输入.请输入')+$t('详细地址')" />-->
      <!--      </a-form-model-item>-->
    </a-form-model>
  </a-modal>
</template>

<script>
import { getVideo, addVideo, updateVideo } from '@/api/video/video'
import { listRecommendCategory } from '@/api/video/recommendCategory'
import {mapGetters} from 'vuex'
import {listTopic } from '@/api/video/topic'

import {listUser} from '@/api/biz/user'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle";
import OssUploadMulti from "@/components/OssUploadMulti";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
    OssUploadSingle, OssUploadMulti,
  },
  data () {
    return {
      userList:[],
      topicList:[],
      categoryOptions:[],

      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        videoContent: null,

        videoPic: null,

        videoUrl: null,
        videoUrlList: null,
        videoBusinessId: null,

        playNum: null,

        likeNum: null,

        videoState: '0',

        createTime: null,

        videoPid: null,

        videoPids: [],

        videoDuration: null,

        putInHours: null,

        auditOpinion: null,

        atUser: null,

        videoType: '0',

        topicId: null,
        creator: null,
        shareNum: null,

        replyNum: null,

        isReward: null,
        video: null,

        videoBusinessType: null,

        pubLat: null,

        pubLng: null,

        limitShow: null,

        address: null,

        lastEditTime: null,

        remark: null,

        reason: null,

        pubCity: null,

        richContent: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        creator: [{required: true, message: this.$t('请选择发布人'), trigger: 'blur'}],
        // videoContent: [{required: true, message: this.$t('描述') + this.$t('通用.文本.不能为空'), trigger: 'blur'}],
        videoType: [{required: true, message: this.$t('类型') + this.$t('通用.文本.不能为空'), trigger: 'blur'}],
        videoState: [{required: true, message: this.$t('视频状态') + this.$t('通用.文本.不能为空'), trigger: 'blur'}],
        // videoUrlList: [{required: true, message: this.$t('请上传'), trigger: 'blur'}],
        videoUrl: [{required: true, message: this.$t('请上传'), trigger: 'blur'}]
      }
    }
  },
  filters: {
  },
  created () {
    this.getUserList()
    this.getTopicList()
    this.getCategoryList()
  },
  computed: {
    ...mapGetters(['customDict']),
    richContentSrcdoc () {
      // iframe 沙箱隔离富文本：里面的 position:fixed / 超大 width 全部被关在 iframe 内，不可能影响外层页面
      const content = this.form.richContent || ''
      return '<!DOCTYPE html><html><head><meta charset="utf-8">' +
        '<style>' +
        'html,body{margin:0;padding:12px;background:#f5f5f5;word-break:break-word;}' +
        'img{max-width:100%;height:auto;}table{max-width:100%;}video,iframe{max-width:100%;}' +
        'p{margin:0 0 8px;}' +
        '</style></head><body>' + content + '</body></html>'
    }
  },
  watch: {
  },
  mounted () {
  },




  methods: {

    onClose () {
      this.open = false
      this.reset()
      this.$emit('close')
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        videoContent: null,
        videoPic: null,
        videoUrl: null,
        videoUrlList: null,
        videoBusinessId: null,
        playNum: null,
        likeNum: null,
        videoState: null,
        createTime: null,
        videoPid: null,
        videoPids: [],
        videoDuration: null,
        putInHours: null,
        auditOpinion: null,
        atUser: null,
        videoType: null,
        topicId: null,
        creator: null,
        shareNum: null,
        replyNum: null,
        isReward: null,
        videoBusinessType: null,
        pubLat: null,
        pubLng: null,
        limitShow: null,
        address: null,
        lastEditTime: null,
        remark: null,
        pubCity: null,
        richContent: null
      }

    },

    handleTopicSearch(value) {
      listTopic(({"topicTitle": value})).then(response => {
        this.topicList = response.data
      })
    },

    handleTopicChange(value) {
      this.topicId = value.id;
      this.getTopicList()
    },
    getTopicList() {
      listTopic().then(response => {
        this.topicList = response.data
      })
    },
    // 视频分类列表
    getCategoryList() {
      listRecommendCategory({}).then(response => {
        this.categoryOptions = response.data
      })
    },
    //用户选择：输入手机号按手机号搜索，否则按昵称搜索
    handleUserSearch(value) {
      const param = {}
      if (/^\d+$/.test(value)) {
        param.mobile = value
      } else {
        param.nickName = value
      }
      listUser(param).then(response => {
        this.userList = response.data
      })
    },

    handleUserChange(value) {
      this.creator = value.id;
      this.getUserList()
    },
    getUserList() {
      listUser().then(response => {
        this.userList = response.data
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      // 新增默认审核通过
      this.form.videoState = '3'
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getVideo({"id":id}).then(response => {
        this.form = response.data
        this.form.videoPids = this.form.videoPids ? this.form.videoPids.split(',').filter(Boolean) : []
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      // 先组装视频/图片地址，保证校验时 videoUrl 已有值
      if (this.form.videoType == '1') {
        // 集合转成字符串
        this.form.videoUrl = this.form.videoUrlList && this.form.videoUrlList.length ? this.form.videoUrlList.join(',') : null
      }
      if (Array.isArray(this.form.videoPids)) {
        this.form.videoPids = this.form.videoPids.length ? this.form.videoPids.join(',') : null
      }
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        // 视频类型必须上传封面
        if (this.form.videoType == '0' && !this.form.videoPic) {
          this.$message.error(this.$t('请上传视频封面'))
          return false
        }
        this.submitLoading = true
        let message = ''
        if (this.form.id !== undefined && this.form.id !== null) {
          message = this.$t('通用.文本.修改成功')
          updateVideo(this.form).then(response => {
            this.$message.success(
              message,
              3
            )
            this.open = false
            this.$emit('ok')
            this.$emit('close')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          message = this.$t('通用.文本.新增成功')
          addVideo(this.form).then(response => {
            this.$message.success(
              message,
              3
            )
            this.open = false
            this.$emit('ok')
            this.$emit('close')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
/** Button按钮间距 */
.ant-btn {
  margin-left: 30px;
  margin-bottom: 30px;
  float: right;
}
.imageDiv{
  float: left;width:150px;height:200px;margin-right: 10px;margin: 0 8px 8px 0;
}
.imageDiv .imageDivBorder{
  width: 100%;height: 100%;position: relative;padding: 8px;border: 1px solid #d9d9d9;border-radius: 4px;
}
.imageDiv .imageDivBorder img{
  width: 100%;
  height: 100%;
}
.rich-content-iframe {
  display: block;
  width: 100%;
  height: 300px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #f5f5f5;
}
</style>